var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_6242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21732 15.6139V7.71303L2.85689 5.47138L0.740234 4.22742V14.2196C0.740234 14.9911 1.34237 15.6139 2.08339 15.6139H5.21732Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9629 15.6139H19.0968C19.8401 15.6139 20.44 14.9888 20.44 14.2196V4.22754L18.0425 5.65235L15.9629 7.71307V15.6139Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21767 7.71314L4.89648 4.62604L5.21767 1.67139L10.5901 5.85419L15.9626 1.67139L16.3219 4.46652L15.9626 7.71314L10.5901 11.8959L5.21767 7.71314Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9629 1.67138V7.71313L20.44 4.22751V2.36848C20.44 0.644288 18.5439 -0.338627 17.2166 0.695411L15.9629 1.67138Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740234 4.22755L2.79933 5.83073L5.21732 7.71316V1.67141L3.96366 0.695447C2.63397 -0.33867 0.740234 0.644324 0.740234 2.36844V4.22755Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_6242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6991,
    height: 15.4167,
    fill: "white",
    transform: "translate(0.740234 0.273193)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLanding);
export default __webpack_public_path__ + "static/media/mail_landing.562bbebfa860a284fd5e70f393198274.svg";
export { ForwardRef as ReactComponent };